<template>
  <div v-if="ready==false"><WetterOffline/></div>
  <div v-if="ready" class="grid-container">
  <div v-if="sio_received==false"><h1>Warte auf Daten des 7:1 Sensors</h1></div>
  <div v-if="lightning_received==false"><h1>Warte auf Daten des  Gewittersensors</h1></div>
  <div v-if="feinstaub_ready==false"><h1>Warte auf Daten des Feinstaubsensors</h1></div>
  <SevenInOne v-if="sio_received"
        :temp_c="temp_c" 
        :humidity="humidity" 
        :light_klx="light_klx" 
        :uv_index="uv_index"
        :wind_speed="wind_speed"
        :gust="gust" 
        :wind_direction="wind_direction"
        :wind_dirtext="wind_dirtext"
        :rain="rain"
        :rain_h="rain_h"
        :rain_d="rain_d"
        :rain_w="rain_w"
        :rain_m="rain_m"
  />
  <div class="grid-item bg-pres" v-flash="'dust'" v-if="feinstaub_ready">  <AirPressure
                             :pres="pres" /></div>
  <div class="grid-item bg-dust" v-flash="'dust'" v-if="feinstaub_ready">  <AirDust
                                 :pm25="fs_25" 
                                 :pm10="fs_10"
                                 :age="fs_age"
                                 />
  </div>
  <LightningValues v-if="lightning_received"
        :dist="lightning_distance" 
        :delay_lastevent_number="lightning_delay" 
        :delay_lastevent_unit="lightning_unit" 
        :current_rate="lightning_rate" 
  />

  <div class="grid-item bg-radio" v-flash="'geiger'" v-if="geiger_ready==true">
        <GeigerCounter 
               :Dosisleistung="Dosisleistung"
               :Aktivitaet="Aktivitaet" 
               :Sensitivitaet="Sensitivitaet" 
        /> 
  </div>

  <div class="grid-item bg-signal" v-flash="'signal'"><SignalStrength
                                 :wifi="rssi_wifi"
                                 :seveninone="rssi_sio"
                                 :lightning="rssi_lightning"
                                 :feinstaub="rssi_feinstaub"
                          />
  </div>
  <div class="grid-item bg-bat" v-flash="'bat'"><BatteryStatus
                                 :sio_bat="sio_bat"
                                 :lightning_bat="lightning_bat"
                          />
  </div>
  <div class="grid-item bg-thanks" >
  Danke an:
  <ul>
  <li>Vercel</li>
  <li>Font Awsome</li>
  <li>YL of DC4DIY</li>  
  </ul>
  </div>

</div>  
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import mqtt from 'mqtt'
import { pulse } from './flash'

// MQTT Client Optionen
const options = {
  clean: true, // clean session
  connectTimeout: 4000, // Timeout
  // Auth optional
  clientId: 'vue_client_' + Math.random().toString(16).substr(2, 8),
}

// MQTT Broker URL
const connectUrl = 'wss://broker.emqx.io:8084/mqtt' // Wichtig: WSS für Websockets (für Browser)

// Topic, das wir abonnieren wollen
const topic = 'ESPWeather-dc4diy-CF312C/#'

// Reaktive Werte für den Status und die empfangenen Nachrichten
const isConnected = ref(false)

let client = null

const ready = ref(false)
const feinstaub_ready = ref(false)
const geiger_ready = ref(false)
const sio_received = ref(false)
const lightning_received = ref(false)
const temp_c=ref()
const pres= ref()
const humidity=ref()
const light_klx=ref()
const uv_index=ref()
const wind_speed=ref()
const wind_direction=ref()
const wind_dirtext=ref()
const rssi_wifi=ref()
const rssi_sio=ref()
const rssi_lightning=ref()
const rssi_feinstaub=ref()
const lightning_rate= ref()
const lightning_distance=ref()
const lightning_delay=ref()
const lightning_unit=ref()
const sio_bat=ref()
const lightning_bat=ref()
const rain=ref()
const rain_h=ref()
const rain_d=ref()
const rain_w=ref()
const rain_m=ref()
const gust=ref()
const fs_25=ref()
const fs_10=ref()
const fs_age=ref()
const Dosisleistung=ref()
const Aktivitaet=ref()
const Sensitivitaet=ref()

onMounted(() => {
  // Verbindung aufbauen
  client = mqtt.connect(connectUrl, options)

  // Events behandeln
  client.on('connect', () => {
    console.log('AppConnected')
    isConnected.value = true
    client.subscribe(topic, (err) => {
      if (!err) {
        //console.log(`AppSubscribed to ${topic}`)
        console.log(`AppSubscribed`)
      } else {
        console.error('AppSubscription error:', err)
      }
    })
  })

  client.on('message', (topic, payload) => {
//    console.log('AppReceived:', topic, payload.toString())
    if(topic=="ESPWeather-dc4diy-CF312C/7in1/data"){
      console.log("7in1 Data received")
      pulse('7in1'); pulse('bat')
      sio_received.value=true
      const telegram= JSON.parse(payload.toString())
      temp_c.value=telegram.temp_c
      humidity.value=telegram.humidity
      light_klx.value=telegram.light_klx
      uv_index.value=telegram.uv
      wind_speed.value=telegram.wind_avg
      wind_direction.value=telegram.wind_dir
      gust.value=telegram.wind_gust
      if(telegram.battery_ok==1){
        sio_bat.value="ok"
      }else{
        sio_bat.value="bitte beobachten"
      }
      rain.value=telegram.rain
      rain_h.value=telegram.rain_h
      rain_d.value=telegram.rain_d
      rain_w.value=telegram.rain_w
      rain_m.value=telegram.rain_m

    }
    
    if(topic=="ESPWeather-dc4diy-CF312C/LightningSensor/data"){
      console.log("Lightning Data received")
      pulse('lightning'); pulse('bat')
      lightning_received.value=true
      const telegram= JSON.parse(payload.toString())
      lightning_rate.value=telegram.lightning_hr
      lightning_distance.value=Math.round(telegram.lightning_distance_km/1.6)
      if(telegram.battery_ok==1){
        lightning_bat.value="ok"
      }else{
        lightning_bat.value="bitte beobachten"
      }
      const now= Date.now()
      const last=new Date(telegram.lightning_event_time).getTime()
      const diffMs= now-last
      const minutes=Math.floor(diffMs / (1000 * 60));
      const hours = Math.floor(diffMs / (1000 * 60 * 60));
      const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      console.log(minutes, hours, days)
      if (days>=2) {   //Ab drei Tagen
        lightning_delay.value=days
        lightning_unit.value="Tage"     
      } else if (hours>1) {  //Ab 2 Stunden
        lightning_delay.value=hours
        lightning_unit.value="Stunden"
      } else {               // 1..119 Minuten
        lightning_delay.value=minutes
        lightning_unit.value="Minuten" 
     }
    }
    
    if(topic=="ESPWeather-dc4diy-CF312C/feinstaub"){
      console.log("feinstaub received")
      pulse('dust'); pulse('signal')
      const telegram= JSON.parse(payload.toString())
      feinstaub_ready.value=true
      pres.value=telegram.pres
      fs_25.value=telegram.pm25
      fs_10.value=telegram.pm10
      fs_age.value=telegram.age
      rssi_feinstaub.value=telegram.rssi
    }

    if(topic=="ESPWeather-dc4diy-CF312C/radio"){
      console.log("Wifi RSSI received")
      pulse('signal')
      const telegram= JSON.parse(payload.toString())
      rssi_wifi.value=telegram.rssi
    }

    if(topic=="ESPWeather-dc4diy-CF312C/FS-5000/data"){
      console.log("Geigercounter received")
      pulse('geiger')
      const telegram= JSON.parse(payload.toString())
      Dosisleistung.value=telegram.Dosisleistung
      Aktivitaet.value=telegram.Aktivitaet
      Sensitivitaet.value=telegram.Sensitivitaet
      geiger_ready.value=true
    }

    if(topic=="ESPWeather-dc4diy-CF312C/FS-5000/status"){
      console.log("Geigercounter received")
      if(payload.toString()=="offline"){
         geiger_ready.value=false
      }
    }

    if(topic=="ESPWeather-dc4diy-CF312C/7in1/rssi"){
      console.log("7in1 RSSI received")
      pulse('signal')
      rssi_sio.value=Number(payload.toString())
    }

    if(topic=="ESPWeather-dc4diy-CF312C/7in1/ESPWeather-dc4diy-CF312C/extra"){
      console.log("7in1 extra data received");
      const telegram= JSON.parse(payload.toString())
      wind_dirtext.value=telegram.wind_dir_txt.replaceAll("E","O")
    }

    if(topic=="ESPWeather-dc4diy-CF312C/LightningSensor/rssi"){
      console.log("Lightning RSSI received")
      pulse('signal')
      rssi_lightning.value=Number(payload.toString())
    }

    if(topic=="ESPWeather-dc4diy-CF312C/status"){
      if(payload.toString()=="online")
        {
          console.log("ONLINE!!!")
          ready.value=true
        }
        else
        {
          console.log("Offline")
          ready.value=false
        }
    }
  })

  client.on('error', (err) => {
    console.error('AppConnection error:', err)
  })

  client.on('close', () => {
    console.log('AppDisconnected')
    isConnected.value = false
  })
})

onBeforeUnmount(() => {
  if (client) {
    client.end()
  }
})
</script>





<script>
import WetterOffline from './components/wetter_offline.vue'
import SevenInOne from './components/seven_in_one.vue'
import LightningValues from './components/lightning.vue'
import SignalStrength from './components/signal_strength.vue'
import BatteryStatus from './components/batterys.vue'
import AirPressure from './components/air_pressure.vue'
import AirDust from './components/air_dust.vue'
import GeigerCounter from './components/geiger_counter.vue'

export default {
  name: 'App',
  components: {
    WetterOffline,
    SevenInOne,
    LightningValues,
    SignalStrength,
    BatteryStatus,
    GeigerCounter
  }
}

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 22px;
  margin-left: 22px;
  margin-right: 22px;
}
.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.grid-item h1 {
  margin: 0 0 6px;
  font-size: 2em;
  line-height: 1;
}

.grid-item u {
  display: inline-block;
  margin-bottom: 8px;
  font-size: 1.15em;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-underline-offset: 4px;
}

.grid-item b {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

/* short highlight when new MQTT data arrives (see flash.js) */
.mqtt-flash {
  animation: mqtt-flash 1.2s ease-out;
}

@keyframes mqtt-flash {
  0% { box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.95), 0 0 18px 4px rgba(255, 255, 255, 0.7); }
  100% { box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); }
}

.grid-item {
  line-height: 1.4;
  background-color: #f2f2f2;
  grid-auto-rows: max-content;
  padding: 40px;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  color: white;
}
</style>

<style scoped>
.bg-signal     { background-color: #3a7d4d; }
.bg-bat        { background-color: #2d5e4a; }
.bg-pres       { background-color: #3A789C; }
.bg-dust       { background-color: #C46A60; }
.bg-thanks     { background-color: #3a4a5e; }
.bg-radio      { background-color: #ffff00; color: #000000; }
</style>
